import React, { useEffect } from 'react'
import Footer from './footer';
import Navigation from './navigation';
import * as styles from '../styles/layout.module.css'

import { ReactComponent as FooterDecor } from "../assets/VJF23footer_decor.svg"
import { ReactComponent as Clip } from "../assets/artist_clip.svg"


interface LayoutProps {
    children?: React.ReactNode
    main_style?: React.CSSProperties
    nav_background?: boolean
}

const Layout = ({ children, main_style, nav_background = true}  : LayoutProps) => {

  useEffect(() => {
    if (nav_background) {
      document.documentElement.style.setProperty('--gradient-percentage', `100%`)
      document.documentElement.style.setProperty('--gradient-percentage-shifted', `0%`)
    }
  }, [])

  return (
    <>
    <Navigation/>
    {/* <BackgroundDecor className={styles.bg_decor}/> */}
    <main style={{position: 'relative', ...main_style}}>
      {children}
      <FooterDecor className={styles.footer_decor} id='footer-decor'/>
    </main>
    <Footer/>
    <Clip />
    </>
  )
}

export default Layout